/* Modulo: Category Icons
   Two jobs, both small:
   1. Desktop arrows: shown only while the row overflows, hidden at each end.
      The rail is a native scroller, so with no script it still scrolls.
   2. GIFs under reduced motion: a looping GIF is motion nobody asked for
      (WCAG 2.2.2), and CSS cannot pause one. Its current frame is painted to
      a canvas that takes its place; the <img> stays in the DOM, so the link's
      name does not change. A live media-query listener reverses it. */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(RM && RM.matches); }

  /* A canvas ignores object-fit, so the frame is drawn into a SQUARE canvas
     with the same geometry the <img> used: contain (letterboxed) for the
     default fit, a centred crop for "fill the circle". */
  function freeze(img) {
    if (img.__ciCanvas) return;
    if (!img.complete || !img.naturalWidth) {
      img.addEventListener('load', function () { if (reduced()) freeze(img); }, { once: true });
      return;
    }
    var w = img.naturalWidth, h = img.naturalHeight;
    var cover = !!img.closest('.modulo-ci--fit-cover');
    var side = cover ? Math.min(w, h) : Math.max(w, h);
    var c = document.createElement('canvas');
    c.width = side;
    c.height = side;
    try {
      var ctx = c.getContext('2d');
      if (!ctx) return;
      ctx.drawImage(img, (side - w) / 2, (side - h) / 2, w, h);
    } catch (e) {
      return;
    }
    c.className = img.className;
    c.setAttribute('aria-hidden', 'true');
    img.__ciCanvas = c;
    img.style.display = 'none';
    img.parentNode.insertBefore(c, img.nextSibling);
  }

  function thaw(img) {
    if (!img.__ciCanvas) return;
    if (img.__ciCanvas.parentNode) img.__ciCanvas.parentNode.removeChild(img.__ciCanvas);
    img.__ciCanvas = null;
    img.style.display = '';
  }

  function syncMotion(root) {
    var gifs = root.querySelectorAll('[data-ci-gif]');
    for (var i = 0; i < gifs.length; i++) {
      if (reduced()) freeze(gifs[i]); else thaw(gifs[i]);
    }
  }

  function init(root) {
    if (!root || root.__moduloCi) return;
    root.__moduloCi = true;
    var rail = root.querySelector('[data-ci-rail]');
    var prev = root.querySelector('[data-ci-prev]');
    var next = root.querySelector('[data-ci-next]');

    if (rail) {
      var update = function () {
        var max = rail.scrollWidth - rail.clientWidth;
        /* RTL scrollers run 0 -> negative in every current engine; the
           magnitude is what says how far along the row we are. */
        var x = Math.abs(rail.scrollLeft);
        root.classList.toggle('is-scrollable', max > 2);
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= max - 2;
      };
      var page = function (dir) {
        var step = Math.max(rail.clientWidth * 0.8, 120) * dir;
        if (window.getComputedStyle(rail).direction === 'rtl') step = -step;
        rail.scrollBy({ left: step, behavior: reduced() ? 'auto' : 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      rail.addEventListener('scroll', update, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(update).observe(rail);
      else window.addEventListener('resize', update);
      update();
    }

    syncMotion(root);
  }

  function initAll(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-ci]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  /* Document-level listeners are wired ONCE: an identical <script src> still
     executes once per tag, so two installs on a page would otherwise bind
     each listener twice. */
  if (!window.__moduloCiWired) {
    window.__moduloCiWired = true;
    if (RM) {
      var onMotion = function () {
        var els = document.querySelectorAll('[data-modulo-ci]');
        for (var i = 0; i < els.length; i++) syncMotion(els[i]);
      };
      if (RM.addEventListener) RM.addEventListener('change', onMotion);
      else if (RM.addListener) RM.addListener(onMotion);
    }
    /* The theme editor re-renders a section in place; the new node needs its
       own init. */
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
